import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Methodology from './pages/Methodology';
import VisionMission from './pages/VisionMission';
import Careers from './pages/Careers';
import Donation from './pages/Donation';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Partners from './pages/Partners';
import GrievancePolicy from './pages/GrievancePolicy';

import './App.css';

import LoanApplication from './pages/LoanApplication';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <div className="App" style={{ 
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Header />
          <main style={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/methodology" element={<Methodology />} />
              <Route path="/vision-mission" element={<VisionMission />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/apply" element={<LoanApplication />} />
              <Route path="/donation" element={<Donation />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/partners" element={<Partners />} />
              <Route path="/grievance-policy" element={<GrievancePolicy />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
